// hooks/useDbData.js
import { useState } from 'react';
import axios from 'axios';

const useDbData = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [crowdData, setCrowdData] = useState([]);
  const [vehicleData, setVehicleData] = useState([]);
  const [personData, setPersonData] = useState([]);
  const [congestionData, setCongestionData] = useState([]);
  const [loadedStateData, setLoadedStateData] = useState([]);
  const [unloadedStateData, setUnloadedStateData] = useState([]);


  // Fetch data from all databases based on time filter
  const fetchData = async (timeFilter) => {
    setIsLoading(true);
    setError(null);
                 
    try {
      // Define your API endpoints
      const endpoints = {
        crowd: '/api/crowd-detection',
        vehicle: '/api/vehicle-detection',
        person: '/api/person-detection',
        congestion: '/api/vehicle-congestion',
        loaded: '/api/loaded-state',
        unloaded: '/api/unloaded-state'
      };
      
      // Make parallel requests to all endpoints
      const [
        crowdResponse, 
        vehicleResponse, 
        personResponse, 
        congestionResponse,
        loadedResponse,
        unloadedResponse
      ] = await Promise.all([
        axios.get(endpoints.crowd, { params: timeFilter }),
        axios.get(endpoints.vehicle, { params: timeFilter }),
        axios.get(endpoints.person, { params: timeFilter }),
        axios.get(endpoints.congestion, { params: timeFilter }),
        axios.get(endpoints.loaded, { params: timeFilter }),
        axios.get(endpoints.unloaded, { params: timeFilter })
      ]);
      
      // Update state with fetched data
      setCrowdData(crowdResponse.data || []);
      setVehicleData(vehicleResponse.data || []);
      setPersonData(personResponse.data || []);
      setCongestionData(congestionResponse.data || []);
      setLoadedStateData(loadedResponse.data || []);
      setUnloadedStateData(unloadedResponse.data || []);
    } catch (err) {
      console.error("Error fetching data:", err);
      setError(err.response?.data?.message || err.message);
    } finally {
      setIsLoading(false);
    }
  };

  // Function to get data for specific detection type
  const getDataForDetectionType = (typeId, selectedArea, selectedCategory) => {
    let data;
    
    // Get the right dataset based on type
    switch (typeId) {
      case "cd":
        data = crowdData;
        break;
      case "vd":
        data = vehicleData;
        break;
      case "pd":
        data = personData; // Show all person and intrusion events
        break;
      case "vc":
        data = congestionData;
        break;
      case "ls":
        // Combine loaded and unloaded state data with flags
        const lsEvents = loadedStateData.map(event => ({
          ...event,
          loadingState: 'LS'
        }));
        const usEvents = unloadedStateData.map(event => ({
          ...event,
          loadingState: 'US'
        }));
        data = [...lsEvents, ...usEvents];
        break;
      case "ct":
        data = [];
        break;
      default:
        data = [];
    }
    
    // Filter by area if needed
    if (selectedArea && selectedArea !== "All") {
      data = data.filter(item => item.area === selectedArea);
    }
    
    // Filter by category if needed
    if (selectedCategory && selectedCategory !== "All") {
      data = data.filter(item => item.category === selectedCategory);
    }
    
    return data;
  };

  return {
    isLoading,
    error,
    fetchData,
    getDataForDetectionType,
    crowdData,
    vehicleData,
    personData,
    congestionData
  };
};

export default useDbData;